import { useProjectDataStore, useProjectUIStore } from "stores/projectStore";
import useResizeObserver from "use-resize-observer";
import React, { useCallback } from "react";
import { Tree } from "@hogartrabe/react-arborist-vrh";
import { SummaryListItem } from "components/SummaryListItem";

export const VirtualizedProject = () => {
  const toggleNode = useProjectUIStore((state) => state.toggleNode);
  const projectTree = useProjectDataStore((state) => state.projectTree);
  const treeRef = useProjectDataStore((state) => state.treeRef);
  const { ref, width } = useResizeObserver();
  const childrenAccessor = useCallback((d) => d.nodes, []);
  const openMap = useProjectUIStore((state) => state.openMap);

  return (
    <div ref={ref}>
      <Tree
        data={projectTree}
        initialOpenState={openMap}
        childrenAccessor={childrenAccessor}
        indent={32}
        width={width}
        height={650}
        ref={treeRef}
        rowHeight={52}
        paddingBottom={32}
      >
        {({ node, style, ...props }) => (
          <SummaryListItem
            node={node}
            style={{
              ...style,
              paddingLeft: node.level * 12,
            }}
            toggleNode={toggleNode}
            {...props}
          />
        )}
      </Tree>
    </div>
  );
};
